import React, { Component } from "react";
import { Link } from "react-router-dom";
class Hashtag extends Component {
  state = {};
  render() {
    const style = { cursor: "pointer" };
    if (this.props.username) {
      return (
        <Link
          style={style}
          to={
            "/users/" + this.props.username + "/hashtag/" + this.props.hashtag
          }
        >
          <div className="category">
            <div className="category_row cursor_btn">
              <label className="hashtag cursor_btn">#</label>
              <label className="category_name cursor_btn">
                {this.props.hashtag}
              </label>
            </div>
            {this.renderRecommendationNumber()}
          </div>
        </Link>
      );
    }
    return (
      <Link style={style} to={"/hashtag/" + this.props.hashtag}>
        <div className="category">
          <div className="category_row cursor_btn">
            <label className="hashtag cursor_btn">#</label>
            <label className="category_name cursor_btn">
              {this.props.hashtag}
            </label>
          </div>
          {this.renderRecommendationNumber()}
        </div>
      </Link>
    );
  }

  renderRecommendationNumber() {
    if (this.props.recommendation_number) {
      return (
        <label className="hashtag recommendation_number">
          {this.props.recommendation_number}
        </label>
      );
    }
    return <div />;
  }
}

export default Hashtag;



// WEBPACK FOOTER //
// ./src/components/categories/hashtag.jsx